import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { Select, MenuItem, Box, Typography, Avatar } from "@mui/material";

const languages = [
  { code: "en", label: "English", flagCode: "gb" },
  { code: "de", label: "Deutsch", flagCode: "de" },
];

const LanguageSwitcher = ({ style, variant = "default" }) => {
  const { i18n } = useTranslation();
  const location = useLocation();

  const handleChange = (event) => {
    i18n.changeLanguage(event.target.value);
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const langParam = params.get("lang");

    if (langParam && languages.some((lang) => lang.code === langParam)) {
      i18n.changeLanguage(langParam);
    }
  }, [location.search, i18n]);

  const selected = languages.find((lang) => lang.code === i18n.language);
  const isOutline = variant === "outline";

  return (
    <Select
      value={i18n.language}
      onChange={handleChange}
      variant="outlined"
      displayEmpty
      disableUnderline
      renderValue={() => (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Avatar
            src={`https://flagcdn.com/w40/${selected?.flagCode}.png`}
            alt={selected.label}
            sx={{ width: 22, height: 22 }}
          />
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Typography
              variant="caption"
              sx={{
                fontSize: "12px",
                color: "#337D96",
                lineHeight: 1.5,
              }}
            >
              Language
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontWeight: 600,
                fontSize: "14px",
                color: "#134264",
                lineHeight: 1,
              }}
            >
              {selected?.label}
            </Typography>
          </Box>
        </Box>
      )}
      sx={{
        backgroundColor: isOutline ? "rgba(255, 255, 255, 0.2)" : "rgba(255, 255, 255, 0.85)",
        borderRadius: 2,
        minWidth: 160,
        height: 60,
        padding: "3px 12px",
        color: isOutline ? "#fff" : "#000",
        width: "auto",
        maxWidth: "100%",
        boxShadow: "none",
        border: isOutline ? "1px solid #fff" : "none",
        "& .MuiSelect-select": {
          padding: 0,
        },
        "& .MuiOutlinedInput-notchedOutline": {
          border: "none",
        },
        "&:hover .MuiOutlinedInput-notchedOutline": {
          border: "none",
        },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
          border: "none",
        },
        ...style,
      }}
    >
      {languages.map(({ code, label, flagCode }) => (
        <MenuItem key={code} value={code}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Avatar
              src={`https://flagcdn.com/w40/${flagCode}.png`}
              alt={label}
              sx={{ width: 22, height: 22 }}
            />
            <Typography
              variant="body2"
              sx={{
                fontSize: "16px",
                color: isOutline ? "#000" : "inherit",
              }}
            >
              {label}
            </Typography>
          </Box>
        </MenuItem>
      ))}
    </Select>
  );
};

export default LanguageSwitcher;
